var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlutter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3322 0.859863L0.265869 14.9262L4.61967 19.28L23.0399 0.859863H14.3322Z",
    fill: "#47C5FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2337 13.8315L6.70215 21.3631L11.0723 25.7985L15.4181 21.4528L23.0394 13.8315H14.2337Z",
    fill: "#47C5FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0725 25.7984L14.3808 29.1067H23.0395L15.4182 21.4526L11.0725 25.7984Z",
    fill: "#00569E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65332 21.412L11.0072 17.0581L15.4182 21.4528L11.0725 25.7985L6.65332 21.412Z",
    fill: "#00B5F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0725 25.7985L14.6911 24.5977L15.0506 21.8203L11.0725 25.7985Z",
    fill: "url(#paint0_linear)",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 11.2297,
    y1: 22.8941,
    x2: 14.0918,
    y2: 23.9255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutter);
export default __webpack_public_path__ + "static/media/flutter.6331a5f11a41c845a25a5df8619ebe63.svg";
export { ForwardRef as ReactComponent };